import React from "react";
import type { FC } from 'react';
import logoPath from "./HKDollarSymbol.svg"
import './currencyStyles.css'
import { Typography } from "@mui/material";

interface HKDollarSymbolProps {
  [key: string]: any;
}

const HKDollarSymbol: FC<HKDollarSymbolProps> = (props) => {

  return (
    <h1
      // component="div"
      // sx={{
      //   fontSize: {
      //     lg: '2rem',
      //     md: '1.5rem',
      //     sm: '1rem',
      //     xs: '1rem'
      //   },
      //   fontWeight: 'bold'
      // }}
    >
      HK$
    </h1>
  );
};

export default HKDollarSymbol;